import React from "react";
import { Box, CircularProgress, Link } from "@mui/material";

export default function ProgressRing(props) {
  const { pct, onClick, size = 32 } = props;

  return (
    <Link
      onClick={onClick}
      sx={{ cursor: "pointer", color: "#888", display: "inline-flex", alignItems: "center" }}
    >
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          thickness={3}
          size={size}
          variant="determinate"
          value={100}
          sx={{ color: "#DDD", position: "absolute", left: 0, zIndex: 1 }}
        />
        <CircularProgress
          thickness={3}
          size={size}
          variant="determinate"
          value={Number(pct)}
          sx={{ color: "#16a085", position: "relative", zIndex: 2 }}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            zIndex: 0,
            backgroundColor: "#ECECEC",
            borderRadius: "50%",
          }}
        />
      </Box>
    </Link>
  );
}
